import * as React from 'react';
import {useEffect, useState, useRef} from 'react';
import {InputText} from "primereact/inputtext";
import {FloatLabel} from "primereact/floatlabel";
import {Button} from "primereact/button";
import {IconField} from "primereact/iconfield";
import {InputIcon} from "primereact/inputicon";
import FeedWells from "./FeedWells";
import {axiosInstances} from "../lib/axios";
import {ClickStat} from "../lib/types/types";
import {Api} from "../lib/services/mainApi";

interface Props {
    onSuccessfulLogin: () => void;
}

const Login : React.FC<Props> = props => {
    const didMountRef = useRef(false);

    const api = new Api();

    const [email, setemail] = useState<string | undefined>("");
    const [password, setPassword] = useState<string | undefined>("");
    const [showPassword, setShowPassword] = useState<boolean>(false);

    useEffect(() => {
        if(!didMountRef.current) {
            didMountRef.current = true;
        }
    }, []);

    const handleLogin = () => {
        if(!email || !password) return;

        api.api.wfV1LoginCreate({username: email, password, timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone})
            .then(resp => {
                props.onSuccessfulLogin();
            })

    }

    return <div className="w-full h-full flex flex-column justify-content-center align-items-center xl:flex-row">
        <div className={"w-10 xl:w-4 bg-white flex flex-column justify-content-center align-items-center border-round-3xl"} style={{zIndex: "10"}}>
            <div className={"flex flex-wrap flex-column row-gap-4 w-full p-6 "}>
               <FeedWells/>

                <FloatLabel className={"w-full"}>
                    <InputText id="email" className={"p-inputtext-lg w-full"} value={email} onChange={(e) => setemail(e.target.value)}/>
                    <label htmlFor="email">Email</label>
                </FloatLabel>

                <FloatLabel className={"w-full"}>
                    <IconField iconPosition="right">
                        <InputIcon className={showPassword ? "pi pi-eye-slash" : "pi pi-eye"} onClick={() => setShowPassword(!showPassword)}/>
                        <InputText id="password" className={"w-full p-inputtext-lg"} type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} />
                    </IconField>
                    <label htmlFor="password">Password</label>
                </FloatLabel>

                <div className={"flex flex-wrap flex-row row-gap-2 w-full"}>
                    <Button label={"Login"} className={"w-full xl:w-3"} onClick={handleLogin}/>

                </div>
            </div>
        </div>

    </div>
};

export default Login
